import styled from "styled-components";
import { C_WIDTH_CARD_MATERIA } from "./data";

export const Content = styled.div(({ }) => ({
    userSelect: "none",
    cursor: "pointer",
    minHeight: "250px",
    minWidth: C_WIDTH_CARD_MATERIA,
    marginRight: 20
}));